export default __webpack_public_path__ + "static/deeptissue-9559c4c29763d0b156e653827d071731.jpeg";